import PropertyDetailSchema from './PropertyDetailSchema';
import RehabWorksheetSchema from './RehabWorksheetSchema';
import RefinancingSchema from '../schemas/RefinancingSchema';
import UserProfileSchema from './UserProfileSchema';
import ProjectionSchema from './ProjectionSchema';
import PurchaseWorksheetSchema from './PurchaseWorksheetSchema';
import ComparisonSchema from './ComparisonSchema';
import {
  GlobalCriteria,
  BuyAndHoldCriteria,
  RefinanceCriteria,
  PurchaseCriteria,
} from './InvestmentCriteria';
import FlipWorksheetSchema from './FlipWorksheetSchema';
import RehabCashFlowSchema from './RehabCashFlowSchema';
import BRRRRCashFlowSchema from './BRRRRCashFlowSchema';

// import PropertyAssumptionsSchema from './PropertyAssumptionsSchema';
//index for types of forms
const GENERICFORMTYPES = {
  simpleForm: 'simpleForm',
  calculations: 'calculations',
  listForm: 'listForm',
  paginatedForm: 'paginatedForm',
  comparison: 'comparison',
};

const BuyAndHoldAnalysis = {
  name: 'Buy & Hold Analysis',
  sidebarName: 'Analysis Summary',
  summaryPageTitle: 'Post Rehab Analysis',
  pathName: 'summary/buy-and-hold',
  formPathName: 'rehab-worksheet',
  keyMetrics: RehabWorksheetSchema.keyMetrics,
  investmentMetrics: RehabWorksheetSchema.investmentMetrics,
  schema: RehabWorksheetSchema.calculations,
  pathToSource: RehabWorksheetSchema.pathToSource,
  formType: GENERICFORMTYPES.calculations,
};

const BuyAndHoldAnalysisSimple = {
  name: 'Buy & Hold Analysis',
  pathName: 'summary/buy-and-hold',
  formPathName: 'rehab-worksheet',
  schema: RehabWorksheetSchema.simpleCalculations,
  pathToSource: RehabWorksheetSchema.pathToSource,
  formType: GENERICFORMTYPES.calculations,
};

const purchaseAnalysis = {
  name: 'Purchase Analysis',
  sidebarName: 'Analysis Summary',
  summaryPageTitle: 'Purchase Analysis',
  pathName: 'summary/purchase-analysis',
  formPathName: 'purchase-worksheet',
  keyMetrics: PurchaseWorksheetSchema.keyMetrics,
  investmentMetrics: PurchaseWorksheetSchema.investmentMetrics,
  rentRollMetrics: PurchaseWorksheetSchema.rentRollMetrics,
  schema: PurchaseWorksheetSchema.calculations,
  pathToSource: PurchaseWorksheetSchema.pathToSource,
  formType: GENERICFORMTYPES.calculations,
};

const purchaseAnalysisSimple = {
  name: 'Purchase Analysis',
  pathName: 'summary/purchase-analysis',
  formPathName: 'purchase-worksheet',
  rentRollMetrics: PurchaseWorksheetSchema.rentRollMetrics,
  schema: PurchaseWorksheetSchema.simpleCalculation,
  pathToSource: PurchaseWorksheetSchema.pathToSource,
  formType: GENERICFORMTYPES.calculations,
};

const BRRRRAnalysis = {
  name: 'BRRRR Analysis',
  sidebarName: 'Analysis Summary',
  summaryPageTitle: 'BRRRR Analysis',
  pathName: 'summary/brrrr-analysis',
  formPathName: 'refinancing',
  keyMetrics: RefinancingSchema.keyMetrics,
  investmentMetrics: RefinancingSchema.investmentMetrics,
  schema: RefinancingSchema.calculations,
  pathToSource: RefinancingSchema.pathToSource,
  formType: GENERICFORMTYPES.calculations,
};

const BRRRRAnalysisSimple = {
  name: 'BRRRR Analysis',
  pathName: 'summary/brrrr-analysis',
  formPathName: 'refinancing',
  schema: RefinancingSchema.simpleCalculations,
  pathToSource: RefinancingSchema.pathToSource,
  formType: GENERICFORMTYPES.calculations,
};

const flipAnalysis = {
  name: 'Flip Analysis',
  pathName: 'flip-analysis',
  sidebarName: 'Analysis Summary',
  formPathName: 'flip-worksheet',
  keyMetrics: FlipWorksheetSchema.keyMetrics,
  investmentMetrics: FlipWorksheetSchema.investmentMetrics,
  schema: FlipWorksheetSchema.calculations,
  pathToSource: FlipWorksheetSchema.pathToSource,
  formType: GENERICFORMTYPES.calculations,
};

const getFormSteps = (schema) => {
  return schema.inputs.schema
    .map((section) => ({
      label: section.sectionLabel
        .replace('Advanced: ', '')
        .replace('Optional: ', ''),
      id: section.sectionValue,
    }))
    .filter((section) => section.id !== 'embedDataNeeded');
};

//forms that will go into form buster
const FORMS = {
  propertyDescription: {
    name: 'Property Details',
    pathName: '#property-details',
    schema: PropertyDetailSchema,
    formType: GENERICFORMTYPES.simpleForm,
  },
  purchaseWorksheet: {
    name: 'Purchase Worksheet',
    sidebarName: 'Worksheet',
    pathName: 'purchase-worksheet',
    formSteps: getFormSteps(PurchaseWorksheetSchema),
    schema: PurchaseWorksheetSchema,
    formType: GENERICFORMTYPES.simpleForm,
  },
  flipWorksheet: {
    name: 'Flip Worksheet',
    sidebarName: 'Worksheet',
    pathName: 'flip-worksheet',
    formSteps: getFormSteps(FlipWorksheetSchema),
    schema: FlipWorksheetSchema,
    formType: GENERICFORMTYPES.simpleForm,
  },
  rehabWorksheet: {
    name: 'Rehab Worksheet',
    sidebarName: 'Worksheet',
    formSteps: getFormSteps(RehabWorksheetSchema),
    pathName: 'rehab-worksheet',
    schema: RehabWorksheetSchema,
    formType: GENERICFORMTYPES.simpleForm,
  },
  refinancing: {
    name: 'Rehab Refinancing',
    sidebarName: 'Worksheet',
    formSteps: getFormSteps(RefinancingSchema),
    pathName: 'refinancing',
    schema: RefinancingSchema,
    formType: GENERICFORMTYPES.simpleForm,
  },
  BuyAndHoldAnalysis,
  BuyAndHoldAnalysisSimple,

  purchaseAnalysis,
  purchaseAnalysisSimple,

  BRRRRAnalysis,
  BRRRRAnalysisSimple,
  flipAnalysis,

  userProfile: {
    name: 'User Profile',
    pathName: '/users',
    schema: UserProfileSchema,
    pathToSource: UserProfileSchema.pathToSource,
    formType: GENERICFORMTYPES.simpleForm,
  },
  investmentCriteria: {
    name: 'Investment Criteria',
    pathName: '/settings',
    schema: GlobalCriteria,
    pathToSource: GlobalCriteria.pathToSource,
    formType: GENERICFORMTYPES.simpleForm,
  },

  purchaseCriteria: {
    name: 'Purchase Criteria',
    schema: PurchaseCriteria,
    formType: GENERICFORMTYPES.simpleForm,
    pathToSource: PurchaseCriteria.pathToSource,
  },
  buyAndHoldCriteria: {
    name: 'Buy & Hold Criteria',
    schema: BuyAndHoldCriteria,
    formType: GENERICFORMTYPES.simpleForm,
    pathToSource: BuyAndHoldCriteria.pathToSource,
  },
  refinanceCriteria: {
    name: 'BRRRR Criteria',
    schema: RefinanceCriteria,
    formType: GENERICFORMTYPES.simpleForm,
    pathToSource: RefinanceCriteria.pathToSource,
  },

  projectionSharing: {
    name: 'Projections',
    pathName: 'summary/projections',
    schema: ProjectionSchema,
    formType: GENERICFORMTYPES.calculations,
  },
  projection: {
    name: 'Projections',
    pathName: 'projections',
    description: 'Projections for the property under different scenarios.',
    schema: ProjectionSchema,
    formType: GENERICFORMTYPES.calculations,
  },
  cashFlow: {
    name: 'Income & Expenses',
    pathName: 'cash-flow',
    description:
      'Comparison of income and expenses between different scenarios.',
    schema: ComparisonSchema,
    formType: GENERICFORMTYPES.comparison,
  },
  // new
  rehabCashFlow: {
    name: 'Rehab Cash flow',
    description: 'Rehab Cash Flow',
    schema: RehabCashFlowSchema,
    formType: GENERICFORMTYPES.comparison,
  },
  brrrrCashFlow: {
    name: 'BRRRR Cash flow',
    description: 'BRRRR Cash Flow',
    schema: BRRRRCashFlowSchema,
    formType: GENERICFORMTYPES.comparison,
  },
  // end new
  cashFlowSharing: {
    name: 'Income & Expenses',
    pathName: 'summary/cash-flow',
    description:
      'Comparison of income and expenses between different scenarios.',
    schema: ComparisonSchema,
    formType: GENERICFORMTYPES.comparison,
  },
};

//app pages that are not formbuster forms
const PAGES = {
  summary: {
    name: 'Summary',
    pathName: 'summary',
    description: 'Summary analysis of the property under different scenarios.',
  },
  overview: {
    name: 'Overview',
    pathName: 'overview',
    description: 'Overview of the property',
    formSteps: [
      { label: 'Summary', id: 'summary' },
      { label: 'Property Details', id: 'property-details' },
    ],
  },
  rentRoll: {
    name: 'Rent Roll',
    description: 'A list of your units with summary information.',
    pathName: 'rent-roll',
  },
  rentRollSharing: { name: 'Rent Roll', pathName: 'summary/rent-roll' },

  porfolioForecasting: { name: 'Portfolio Forecasting', pathName: 'feature1' },
  findARealtor: { name: 'Find a Realtor', pathName: 'feature2' },
  mortgageBroker: { name: 'Find a Mortgage Broker', pathName: 'feature3' },
  shopYourProperty: { name: 'Shop Your Property', pathName: 'feature4' },
  compareProperties: { name: 'Compare Properties', pathName: 'feature5' },
  photos: {
    name: 'Photos',
    description: 'Photos of the property',
    pathName: 'photos',
  },
  propertyMap: {
    name: 'Map',
    description: 'Map of the property',
    pathName: 'map',
  },
  photosSharing: {
    name: 'Photos',
    description: 'Photos of the property',
    pathName: 'summary/photos',
  },
  propertyMapSharing: {
    name: 'Map',
    description: 'Map of the property',
    pathName: 'summary/map',
  },
};

//for navigating a property, list including all the steps since the steps are not the same as the order of the items in the navigation
const projectMap = new Map();

//for navigating a property in mobile
const mobileProjectMap = new Map();

//for navigating a property in the sidebar
const sideBarMap = new Map();

//flip map is the order in the nav, flip map steps is the order of the steps in the app
const flipMap = new Map();
const flipMapSteps = new Map();

flipMap.set(0, {
  stepName: 'Overview',
  icon: 'houseIcon',
  pathName: 'overview',
  walkthrough: true,
  todo: [PAGES.overview],
});

flipMap.set(1, {
  stepName: 'Flip Analysis',
  icon: 'brrrrIcon',
  walkthrough: true,
  conditionalCompleted: 'flipWorksheetSubmitted',
  todo: [FORMS.flipWorksheet, FORMS.flipAnalysis],
});

flipMap.set('sharing', {
  stepName: 'Analysis',
  icon: 'houseIcon',
  walkthrough: true,
  sharing: true,
  todo: [FORMS.flipAnalysis, PAGES.photos, PAGES.propertyMap],
});

flipMapSteps.set(0, {
  stepName: 'Property',
  walkthrough: true,
  todo: [FORMS.propertyDescription, FORMS.flipWorksheet, FORMS.flipAnalysis],
});

flipMapSteps.set('sharing', {
  stepName: 'Analysis',
  walkthrough: true,
  sharing: true,
  todo: [FORMS.flipAnalysis, PAGES.photos, PAGES.propertyMap],
});

//defines the order of the nav items for the sidebar
sideBarMap.set(0, {
  stepName: 'Overview',
  icon: 'houseIcon',
  pathName: 'overview',
  href: 'overview',
  walkthrough: true,
  todo: [PAGES.overview],
});

sideBarMap.set(1, {
  stepName: 'Purchase Analysis',
  conditionalCompleted: 'purchaseWorksheetSubmitted',
  icon: 'purchaseIcon',
  href: 'summary/purchase-analysis',
  walkthrough: true,
  todo: [FORMS.purchaseWorksheet, FORMS.purchaseAnalysis],
});

sideBarMap.set(2, {
  stepName: 'Rehab Analysis',
  icon: 'buildIcon',
  conditionalCompleted: 'rehabWorksheetSubmitted',
  href: 'summary/rehab-buy-and-hold',
  walkthrough: true,
  todo: [FORMS.rehabWorksheet, FORMS.BuyAndHoldAnalysis],
});

sideBarMap.set(3, {
  stepName: 'BRRRR Analysis',
  icon: 'brrrrIcon',
  conditionalCompleted: 'refinancingWorksheetSubmitted',
  href: 'summary/brrrr-analysis',
  walkthrough: true,
  todo: [FORMS.refinancing, FORMS.BRRRRAnalysis],
});

sideBarMap.set('extraFeatures', {
  stepName: '',
  walkthrough: true,
  todo: [PAGES.rentRoll, FORMS.projection, FORMS.cashFlow],
});

sideBarMap.set('futureFeatures', {
  stepName: 'Tools',
  todo: [
    PAGES.porfolioForecasting,
    PAGES.findARealtor,
    PAGES.mortgageBroker,
    PAGES.shopYourProperty,
    PAGES.compareProperties,
  ],
});

//defines the order of the nav items for mobile
mobileProjectMap.set(0, {
  stepName: 'Property',
  walkthrough: true,
  todo: [PAGES.overview, FORMS.purchaseWorksheet],
});

mobileProjectMap.set(1, {
  stepName: ' ',
  walkthrough: true,
  todo: [FORMS.rehabWorksheet, FORMS.refinancing],
});

mobileProjectMap.set(2, {
  stepName: 'Analysis',
  walkthrough: true,
  todo: [PAGES.summary],
});

mobileProjectMap.set(3, {
  stepName: 'More',
  walkthrough: true,
  todo: [PAGES.rentRoll, FORMS.projection, FORMS.cashFlow],
});

//normal project map for buy and hold / brrr, determines the order of the steps in the app, which is different from the order of the items in the navigation
projectMap.set(0, {
  stepName: 'property-steps',
  walkthrough: true,
  todo: [
    PAGES.overview,
    FORMS.purchaseWorksheet,
    FORMS.purchaseAnalysis,
    FORMS.rehabWorksheet,
    FORMS.BuyAndHoldAnalysis,
    FORMS.refinancing,
    FORMS.BRRRRAnalysis,
    PAGES.rentRoll,
    FORMS.projection,
    FORMS.cashFlow,
  ],
});

//what will show up in the sharing view
projectMap.set('sharing', {
  stepName: 'Analysis',
  icon: 'houseIcon',
  walkthrough: true,
  sharing: true,
  todo: [
    FORMS.purchaseAnalysis,
    FORMS.BuyAndHoldAnalysis,
    FORMS.BRRRRAnalysis,
    PAGES.rentRollSharing,
    FORMS.projectionSharing,
    FORMS.cashFlowSharing,
    PAGES.photosSharing,
    PAGES.propertyMapSharing,
  ],
});

export {
  projectMap,
  sideBarMap,
  flipMap,
  flipMapSteps,
  mobileProjectMap,
  GENERICFORMTYPES,
  FORMS,
  PAGES,
};
